export const calculateMaxValue = (data) => {
  return Math.max(...data);
};
export const calculateMinValue = (data) => {
  return Math.min(...data.filter((d) => d));
};
